import { HttpRequest } from './HttpRequest'

export const GetEmailTemplate = async (requestObject: any) => {
    let data = JSON.stringify(requestObject);
    try {
        const response = await HttpRequest().post(`/email/preview/transfer`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
        return null
    } catch (error) {
        throw new Error('email error')
    }
}

export const SendEmail = async (requestObject: any) => {
    let data = JSON.stringify(requestObject);
    try {
        const response = await HttpRequest().post(`/email/send/transfer`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        return response.data.message
    } catch (error) {
        throw new Error('send email error')
    }
}

export interface IGetEmailTemplateRequest {
    projectId: number
    unitId: number
    unitCode: string
    emailType: number
    flagTransferLetter: boolean
    flagTransferLetterBefore: boolean
    flagTransferChange: boolean
    flagTransferAdjust: boolean
    flagTransferCancel: boolean
    flagTransferOut: boolean
    flagTransferOutCancel: boolean
}